import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import styles from './TransportDetailDialog.module.sass'
import { Requisition } from 'models'
import { useFetchList } from 'store'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'

const Field = ({ label, value, required }) => (
	<div className={styles['field']}>
		<span className={styles['field-label']}>
			{label}
			{required ? '*' : ''}
		</span>
		<span className={styles['field-value']}>{value || '—'}</span>
	</div>
)

const TransportDetailDialog = (props) => {
	const { data } = props
	const { i18n, gotoAppointment } = useGlobal()
	const transport = data || {}

	const requisitionUri = `/clinical_processes/${transport.clinicalProcessId}/transportRequisition/${transport.requisitionId}`

	const { contents, state } = useFetchList(
		[requisitionUri],
		[Requisition.fromJSON]
	)

	const isLoading = state === 'loading'

	const [requisition] = contents

	return isLoading ? (
		<div className={styles['root']}>
			<div className={styles['summary']}>
				<Skeleton
					className={`${styles['skeleton']} ${styles['medium']}`}
				/>
				<Skeleton
					className={`${styles['skeleton-status-content']} ${styles['small']}`}
				/>
			</div>

			<div className={styles['card']}>
				<div className={styles['grid']}>
					<div className={styles['column']}>
						<Skeleton className={`${styles['skeleton']} `} />
						<Skeleton className={`${styles['skeleton']} `} />
					</div>

					<div className={styles['column']}>
						<Skeleton className={`${styles['skeleton']} `} />
						<Skeleton className={`${styles['skeleton']} `} />
					</div>
				</div>
			</div>

			<div className={styles['card']}>
				<h4 className={styles['section-title']}>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</h4>

				<table className={styles['table']}>
					<thead>
						<tr>
							<th>
								<Skeleton
									className={`${styles['skeleton']} ${styles['small']}`}
								/>
							</th>
							<th>
								{' '}
								<Skeleton
									className={`${styles['skeleton']} ${styles['small']}`}
								/>
							</th>
							<th>
								{' '}
								<Skeleton
									className={`${styles['skeleton']} ${styles['small']}`}
								/>
							</th>
						</tr>
					</thead>
					<tbody>
						{Array.from({ length: 3 }).map((_, index) => (
							<tr key={index}>
								<td>
									<Skeleton
										className={`${styles['skeleton']} ${styles['small']}`}
									/>
								</td>
								<td>
									<Skeleton
										className={`${styles['skeleton']} ${styles['small']}`}
									/>
								</td>
								<td>
									<Skeleton
										className={`${styles['skeleton']} ${styles['small']}`}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className={styles['card']}>
				<h4 className={styles['section-title']}>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</h4>

				<div className={styles['observations']}>
					<strong>
						<Skeleton
							className={`${styles['skeleton']} ${styles['medium']}`}
						/>
					</strong>
					<p>
						<Skeleton className={`${styles['skeleton']}`} />
					</p>
				</div>
			</div>
		</div>
	) : (
		<div className={styles['root']}>
			{/* Resumo no topo */}
			<div className={styles['summary']}>
				<div className={styles['summary-main']}>
					<span className={styles['summary-sub']}>
						#{requisition.id}
						{/* ·{' '} */}
						{/* {requisition?.requisitionDate?.tinyDateFormat ?? ''} */}
						{/* ·{' '} */}
						{/* {requisition?.establishment?.name ?? ''} */}
					</span>
					{/* <span className={styles['summary-id']}>
						#{requisition.id}
					</span> */}
					<div>
						<small>{i18n`Requested at ${requisition?.requisitionDate?.shortDateFormat}, by`}</small>
						<small
							className={styles['appointment']}
							onClick={() =>
								gotoAppointment(
									requisition?.processId,
									requisition?.appointment?.id
								)
							}
						>
							{transport.originRequisition}
							{/* {`${requisition?.appointment?.medicalSpecialty?.name} #${requisition?.appointment?.id}`} */}
						</small>
					</div>
				</div>
				<span
					className={`${styles['state-badge']} ${
						transport.state?.toLowerCase() === 'aprovada'
							? styles['--approved']
							: styles['--rejected']
					}`}
				>
					{transport.state?.toLowerCase() === 'aprovada'
						? i18n`Approved`
						: i18n`Rejected`}
				</span>
			</div>

			{/* Dados da requisição - duas colunas */}
			<div className={styles['card']}>
				<div className={styles['grid']}>
					<div className={styles['column']}>
						{/*	<Field
							label={i18n`Appointment`}
							value={transport.appointment}
						/>  */}
						<Field
							label={i18n`Requisition type`}
							value={i18n`Transport`}
							required
						/>

						{/*	<Field
							label={i18n`Next appointment date`}
							value={transport.nextAppointmentDate}
						/>  */}
						<Field
							label={i18n`Origin Provider`}
							value={requisition.requiringEstablishment.name}
						/>
					</div>
					<div className={styles['column']}>
						<Field
							label={i18n`Destination Provider`}
							value={requisition.establishment.name}
							required
						/>
						{/* <Field
							label={i18n`Accident Date`}
							value={requisition.relapseDate.tinyDateFormat}
						/> */}
						<Field
							label={'Morada alternativa'}
							value={requisition.alternativeAddress ?? '-'}
						/>
					</div>
				</div>
			</div>

			{/* Transport List */}
			<div className={styles['card']}>
				<h4
					className={styles['section-title']}
				>{i18n`Transport List`}</h4>
				{requisition.transports?.length ? (
					<table className={styles['table']}>
						<thead>
							<tr>
								<th>{i18n`Transport type`}</th>
								<th>{i18n`Transport date`}</th>
								<th>{i18n`Transport time`}</th>
							</tr>
						</thead>
						<tbody>
							{requisition.transports.map((transport, index) => (
								<tr key={index}>
									<td>{transport.transportType}</td>
									<td>
										{
											transport.transportDateTime
												.tinyDateFormat
										}
									</td>
									<td>
										{
											transport.transportDateTime
												.shortTimeFormat
										}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<p>{i18n`No transports`}</p>
				)}
			</div>

			{/* Informação */}
			<div className={styles['card']}>
				<h4 className={styles['section-title']}>{i18n`Information`}</h4>
				<div className={styles['observations']}>
					<strong>{i18n`Observations`}</strong>
					<p>{requisition.observations ?? i18n`No observations`}</p>
				</div>
			</div>
		</div>
	)
}

export default TransportDetailDialog
